<template>
  <v-list-item dense
               style="z-index: 15; position: relative;"
               :style="{color: `${this.textColor} !important`}"
               class="pl-7 text-wrap"
               @click="handleLayerOn(layer)"
  >
    <v-list-item-content :title="layer.title">
      <v-list-item-title v-text="layer.title"></v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="isActive">
      <div>
<!--        <v-tooltip right v-if="layer.description"
                   content-class="xm-layercontrol__tooltip elevation-0"
        >
          <template #activator="{on, attrs}">
            <v-icon @click.stop small v-bind="attrs" v-on="on">mdi-information</v-icon>
          </template>
          <span>{{ layer.description }}</span>
        </v-tooltip>-->
        <v-icon v-if="!error" :color="textColor" small>mdi-check-circle</v-icon>
        <v-icon v-else color="error" small>mdi-{{ error }}</v-icon>
      </div>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'LayerControlLayer',

  computed: {
    ...mapState('layers', ['active']),
    ...mapGetters('layers', ['LAYERS']),
    isActive() {
      return this.active.indexOf(this.layer.layerid) > -1;
    },
    error() {
      return this.layer.mapstate?.message || null;
    },
    par() {
      return this.$parent;
    },
  },

  mounted() {
    console.dir(this.par);
  },

  props: {
    layer: {
      type: Object,
      default() {
        return {};
      }
    },
    textColor: {
      type: String,
      default: 'primary'
    }
  },

  methods: {
    showInfo() {
      console.log('show');
    },
    handleLayerOn(layer) {
      if (this.active.indexOf(layer.layerid) > -1) {
        this.$store.dispatch('layers/REMOVE_LAYER', layer.layerid);
      } else {
        console.dir(layer);
        this.$store.dispatch('layers/ADD_LAYER', { layer });
      }
    },
  },

  data() {
    return {
      showInfo: false
    };
  }
};
</script>

<style lang="scss">
.xm-layercontrol__tooltip {
  width: 299px;
  background-color: white;
  color: #263746;
  padding: 5px 5px 5px 5px;
  border: 1px solid #263746;
}
</style>
